export const pathMatches = (path, args = {}) => {
  return ({ location }) => {
    const {
      hash,
      isExact = true,
    } = args;

    let realPath = location.pathname;
    if (typeof path === 'string' && path.includes('?')) realPath += location.search;

    if (isExact && path !== realPath) {
      return false;
    }

    if (!isExact && !realPath.includes(path)) {
      return false;
    }

    if (hash && `#${hash}` !== location.hash) {
      return false;
    }

    return true;
  };
};
